<template>
  <div>
    <Button
      class="btn-color9"
      @click="requestURL"
      :loading="loader"
    >
      {{ buttonText }}
    </Button>
  </div>
</template>

<script>

import GoogleIntegrationService from '@/modules/integrations/services/google-integration-service'

import Button from '@/components/common/Button/Button'

export default {
  name: 'GoogleIntegrationButton',
  props: ['redirectUri', 'text'],
  components: {
    Button
  },
  data () {
    return {
      loader: false
    }
  },
  computed: {
    /**
     * Button text
    */
    buttonText () {
      return this.text || this.$t('integrate_with_google')
    }
  },
  methods: {
    async requestURL () {
      this.loader = true
      try {
        const data = await GoogleIntegrationService.getOAuthURL({
          redirect_uri: this.redirectUri
        })
        window.location.href = data.url
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
